import { render, staticRenderFns } from "./backAct.vue?vue&type=template&id=4d8443bb&"
import script from "./backAct.vue?vue&type=script&lang=js&"
export * from "./backAct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports